/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoAutomaticPickupEmailInput = {
    clientMutationId?: string | null;
    containerSlug: string;
};
export type ContainerPickSentAutomaticPickupEmailMutationVariables = {
    input: infoAutomaticPickupEmailInput;
};
export type ContainerPickSentAutomaticPickupEmailMutationResponse = {
    readonly infoAutomaticPickupEmail: {
        readonly clientMutationId: string | null;
    } | null;
};
export type ContainerPickSentAutomaticPickupEmailMutation = {
    readonly response: ContainerPickSentAutomaticPickupEmailMutationResponse;
    readonly variables: ContainerPickSentAutomaticPickupEmailMutationVariables;
};



/*
mutation ContainerPickSentAutomaticPickupEmailMutation(
  $input: infoAutomaticPickupEmailInput!
) {
  infoAutomaticPickupEmail(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoAutomaticPickupEmailPayload",
    "kind": "LinkedField",
    "name": "infoAutomaticPickupEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContainerPickSentAutomaticPickupEmailMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContainerPickSentAutomaticPickupEmailMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "369f3f0301e477880f68ead7a35102c7",
    "id": null,
    "metadata": {},
    "name": "ContainerPickSentAutomaticPickupEmailMutation",
    "operationKind": "mutation",
    "text": "mutation ContainerPickSentAutomaticPickupEmailMutation(\n  $input: infoAutomaticPickupEmailInput!\n) {\n  infoAutomaticPickupEmail(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '20f68cbce430276f88d16680499e1aa3';
export default node;
